<!-- eslint-disable max-len -->
<!-- eslint-disable no-throw-literal -->
<!--
  V 0.6.0 - 2025-05-07
      - Added ipinfo.io data
      - Added platform data

  V 0.5.0 - 2024-07-22
     - Added re-creation of  "axios-cache-interceptor" on login.

  V 0.4.0 - 2023-12-19
     - Added ability to recieve name and password via the
       router.

  Ver 0.3.0 - 2023-05-08
       - Added version check button from AppBase

   Ver 0.2.20 - 2023-03-20
       - Changed the verison and yeawr to be prefixed with $

   Ver 0.2.1 - 2022-02-21
       - Icons not displaying correctly.

   Ver 0.2.0 - 2022-02-15
       - Added Loading spinner below login button

   Ver  0.1.0  - 2022-02-07
       - Positioning IN middle os screen was not working, had te rmove old layout
         and flex, with v-row and v-col,
-->

<template>
  <div id="app">
    <v-app dark="dark">
      <v-container fill-height fluid class="login-form">
        <v-row justify="center" align="center">
          <v-col cols="12" sm="10">
            <div class="display-1 mb-3">
              <v-icon class="mr-2" large="large">mdi-briefcase</v-icon>{{ $applicationName }} Login
            </div>

            <v-card light="light">
              <v-card-text>
                <div class="subheading">
                  <template v-if="options.isLoggingIn">
                    Log in to your customer portal
                  </template>
                  <!--

                      <template v-else=""> Create a new account
                      </template>

                  -->
                </div>

                <v-form>
                  <v-text-field v-model="user.Email"
                                light="light"
                                prepend-icon="mdi-account-circle"
                                label="User Name / Email"
                                type="email"></v-text-field>

                  <v-text-field v-model="user.Password"
                                light="light"
                                prepend-icon="mdi-lock"
                                label="Password"
                                type="password"></v-text-field>
                  <!--

                    <v-checkbox v-if="options.isLoggingIn" v-model="options.shouldStayLoggedIn" light="light" label="Stay logged in?" hide-details="hide-details"></v-checkbox>

                  -->

                  <v-btn @click.prevent
                         block="block"
                         @click="btnSignIn_click()"
                         type="submit">Sign in</v-btn>
                  <!--
                      <v-btn v-else="v-else" block="block" type="submit" @click.prevent="(options.isLoggingIn = true)">Sign up</v-btn>
                  -->
                </v-form>

                <v-progress-linear indeterminate
                                   color="blue"
                                   :active="loadingShow"></v-progress-linear>
              </v-card-text>
            </v-card>

            <v-alert dense
                     outlined
                     dismissible
                     type="error"
                     v-if="!options.isLoggingIn">
              <strong> Error:</strong> Unable to login. <strong> </strong>
              {{ options.message }}
            </v-alert>

            <v-card light="light" class="pa-2" v-if="debug">
              <div v-if="locationData">
                <p><strong>IP:</strong> {{ locationData.ip }}</p>
                <p><strong>City:</strong> {{ locationData.city }}</p>
                <p><strong>Region:</strong> {{ locationData.region }}</p>
                <p><strong>Country:</strong> {{ locationData.country }}</p>

                <p><strong>Location:</strong> {{ locationData.loc }}</p>
                <p><strong>Organisation:</strong> {{ locationData.org }}</p>
              </div>
            </v-card>

            <v-card light="light" class="pa-2" v-if="updateExists">
              <v-btn @click="refreshApp"
                     block="block">
                New version available! Click to update
              </v-btn>
            </v-card>

          </v-col>
        </v-row>

      </v-container>
      <v-footer app="app">
        <v-flex class="text-xs-center">
          © {{ $year }}. {{ $company }}. All rights reserved. Version
          {{ $version }}
        </v-flex>
      </v-footer>
    </v-app>
  </div>
</template>

<script>

import axios from 'axios'
import { setupCache } from 'axios-cache-interceptor'
import MobileDetect from 'mobile-detect'

export default {
  data () {
    return {
      deviceInfo: '',
      debug: this.$debug,
      locationData: null,
      //
      controlRoomLogin: false,
      // 2023-05-09 - Added for refresh version check
      refreshing: false,
      registration: null,
      updateExists: false,

      //
      user: {
        Email: '',
        Password: '',
        Name: ''
      },

      options: {
        isLoggingIn: true,
        shouldStayLoggedIn: true,
        message: ''
      },

      year: this.$year,
      company: this.$company,
      version: this.$version,
      loadingShow: false
    }
  },
  /**
        *
        *   V 0.2.0 - 2023-12-19
        *     -  added the ability to recieve a
        *
        *   V 0.1.0 - 2023-05-09
        *     - Moved check for version from created to
        *       mounted.
        *
        * */
  mounted () {
    var name = ''
    var pass = ''
    console.log('name:' + this.$route.params.name)

    const md = new MobileDetect(window.navigator.userAgent)

    if (md.tablet()) {
      this.deviceInfo = 'Tablet'
    } else if (md.mobile()) {
      this.deviceInfo = 'Mobile'
    } else {
      this.deviceInfo = 'Desktop'
    }

    if (typeof this.$route.params.name !== 'undefined') {
      name = this.$route.params.name
    }

    if (typeof this.$route.params.pass !== 'undefined') {
      pass = this.$route.params.pass
    }

    if (typeof this.$route.params.all !== 'undefined') {
      this.controlRoomLogin = (this.$route.params.all.toLowerCase() === 'true')
    }

    if (name.length > 0 && pass.length > 0) {
      this.user.Email = name
      this.user.Password = pass

      this.btnSignIn_click()
    }

    //
    //
    this.checkVersion()
    //
  },
  /**
         *
         *   V 0.2.0 - 2025-05-07
         *       - Added fetchLocationData();
         *
         *   V 0.1.0 - 2023-05-09
         *       - Added to check for version on startup
         *
         **/
  created () {
    this.fetchLocationData()

    document.addEventListener(
      'swUpdated', this.showRefreshUI, { once: true }
    )

    if (navigator.serviceWorker) {
      navigator.serviceWorker.addEventListener(
        'controllerchange', () => {
          if (this.refreshing) return
          this.refreshing = true
          window.location.reload()
        }
      )
    }
  },

  methods: {

    //
    // V 0.1.0 - 2025-05-07
    //     - Added fpr djbeaton+raptor@gmail.com

    async fetchLocationData () {
      try {
        const token = '6219438d6dde63' // Optional unless using API key features
        const response = await fetch(`https://ipinfo.io/json?token=${token}`)
        const data = await response.json()
        this.locationData = data
      } catch (err) {
        console.error('Failed to get ipinfo.io location:', err)
      }
    },

    //
    checkVersion () {
      const url = `${this.$baseUrl}/api/AppBase`

      this.$axios
        .get(url)
        .then((response) => {
          if (this.$debug) {
            console.log(response.data)
          }

          if (typeof response.data !== 'undefined') {
            //
            const version = response.data.Version

            if (version > this.$version) {
              this.updateExists = true
            }
            else {
              this.updateExists = false
            }
          } else {
            //
            throw new Error('success parameter on return data was false')
            //
          }
        })
        .catch((e) => {
          if (this.$debug) {
            console.error(e)
          }
        })
    },
    //
    showRefreshUI (e) {
      this.registration = e.detail
      this.updateExists = true
      this.checkVersion()
    },

    refreshApp () {
      // debugger
      this.updateExists = false
      if (!this.registration || !this.registration.waiting) { return }
      this.registration.waiting.postMessage('skipWaiting')
    },

    updateAvailable (event) {
      this.registration = event.detail
      this.updateExists = true
    },

    //

    btnSignIn_click () {
      const url = `${this.$baseUrl}/api/authenticate`

      if (this.$debug) {
        console.log('btnSignIn_Click()')
        console.log(url)
      }

      this.options.isLoggingIn = true
      this.options.message = ''

      this.loadingShow = true

      this.$axios
        .post(url, {
          Email: this.user.Email,
          Password: this.user.Password,
          Name: '',
          Roles: [{ name: 'LOGIN' }],

          Platform: this.deviceInfo,
          Location: this.locationData,
          UnitID: '', // used so we can track this UnitID straigh away if logging in from raptor control
          Version: this.$version // '12'
        })
        .then((response) => {
          this.loadingShow = false

          if (this.$debug) {
            console.log(response.data)
          }

          // debugger

          if (response.data.Success === true) {
            //
            // debugger
            const token = response.data.Token

            const roles = response.data.Roles

            const tenant = response.data.Info

            const debug = response.data.Debug

            const isSimpleLayout = response.data.IsSimpleLayout

            this.$axios.defaults.headers.common.Authorization = `Bearer ${token}`

            this.$store.commit('setToken', token)
            this.$store.commit('setIsLoggedIn', true)
            this.$store.commit('setUserName', this.user.Email)
            //
            // this funciton re-creates the axios object so that the
            // caching object uses it.
            //
            this.$mainFunction()

            this.$store.commit('setTenantCode', tenant)
            this.$store.commit('setRoles', roles)
            this.$store.commit('setDebug', debug)

            this.$store.commit('setControlView', this.controlRoomLogin)

            this.$store.commit('setSimpleView', isSimpleLayout)

            this.$parent.show = true
          }
          else {
            //
            throw new Error('success parameter on return data was false')
            //
          }
        })
        .catch((e) => {
          this.loadingShow = false
          console.log(e)

          this.options.isLoggingIn = false
          if (typeof e.message === 'undefined') {
            this.options.message = 'Error'
          } else {
            this.options.message = e.message
          }
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .login-form {
    max-width: 650px;
  }
</style>
